module.exports = __webpack_public_path__ + "static/media/lamatanza.e942c407.gif";